// @ts-nocheck
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./HeaderStyles.css";
import Logo from "../../assets/logo/logo.svg";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import CookStoveProject from "../../assets/photos/cookstove-project.jpeg";
import LedProject from "../../assets/photos/led-project.avif";
import FoodDigesterProject from "../../assets/photos/food-digester-project.jpeg";
import SolarProject from "../../assets/photos/solar-project.jpeg";
import CarbonOffset from "../../assets/photos/Carbon-Offset.jpeg";
import CarbonFootprinting from "../../assets/photos/carbon-footprinting.jpeg";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [hoveredImage, setHoveredImage] = useState(Logo); // Default logo

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "unset";
  }, [isOpen]);

  useEffect(() => {
    const dropdownMenu = document.querySelector('.dropdown-menu');
    if (dropdownMenu) {
      dropdownMenu.style.animation = isClosing ? "slide-out 500ms" : "";
    }
  }, [isClosing]);

  const handleToggle = () => {
    if (isOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsOpen(false);
        setIsClosing(false);
      }, 500); // Match this duration to the animation duration
    } else {
      setIsOpen(true);
    }
  };

  const handleHover = (newImage) => {
    setHoveredImage(newImage);
  };

  const handleMouseLeave = () => {
    setHoveredImage(Logo);
  };

  return (
    <>
      {["md"].map((expand) => (
        <Navbar key={expand} expand={expand} className="header">
          <Container fluid>
            <img className="navbar-logo" src={Logo} alt="logo" />
            <Navbar.Brand as={Link} to="/">Alphabet Greens</Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Alphabet Greens
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                                    <Nav.Link as={Link} to="/buyers">Buyers</Nav.Link>
                  <Nav.Link as={Link} to="/sellers">Sellers</Nav.Link>
                  <Nav.Link as={Link} to="/investors">Investors</Nav.Link>
                  <Nav.Link as={Link} to="/impact">Our Impact</Nav.Link>
                  <NavDropdown
                    title="What We Do"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                    show={isOpen}
                    onToggle={setIsOpen}
                  >
                    <FontAwesomeIcon
                      className="header-close-btn"
                      icon={icon({ name: "x" })}
                      onClick={handleToggle}
                    />
                    <Row>
                      <Col className="climate-investments" md={4}>
                        <div>
                          <h5>Climate Investments</h5>
                          <b>Community Based Projects</b>
                        </div>
                        <ul>
                          <NavDropdown.Item
                            as={Link}
                            to="/projects/cookstove-project"
                            onClick={() => setIsOpen(false)}
                            onMouseEnter={() => handleHover(CookStoveProject)}
                            onMouseLeave={handleMouseLeave}
                          >
                            <li>The CookStove Projects</li>
                          </NavDropdown.Item>
                          <NavDropdown.Item
                            as={Link}
                            to="/projects/led-project"
                            onClick={() => setIsOpen(false)}
                            onMouseEnter={() => handleHover(LedProject)}
                            onMouseLeave={handleMouseLeave}
                          >
                            <li>The LED Project</li>
                          </NavDropdown.Item>
                          <NavDropdown.Item
                            as={Link}
                            to="/projects/food-digester-project"
                            onClick={() => setIsOpen(false)}
                            onMouseEnter={() => handleHover(FoodDigesterProject)}
                            onMouseLeave={handleMouseLeave}
                          >
                            <li>The Food Digester Project</li>
                          </NavDropdown.Item>
                          <NavDropdown.Item
                            as={Link}
                            to="/projects/solar-project"
                            onClick={() => setIsOpen(false)}
                            onMouseEnter={() => handleHover(SolarProject)}
                            onMouseLeave={handleMouseLeave}
                          >
                            <li>The Solar Project</li>
                          </NavDropdown.Item>
                        </ul>
                      </Col>
                      <Col className="offset-portfolio" md={4}>
                        <div>
                          <h5>Offset Portfolio Management Services</h5>
                        </div>
                        <ul>
                          <NavDropdown.Item
                            as={Link}
                            to="/services/carbon-offset"
                            onClick={() => setIsOpen(false)}
                            onMouseEnter={() => handleHover(CarbonOffset)}
                            onMouseLeave={handleMouseLeave}
                          >
                            <li>Carbon Offset</li>
                          </NavDropdown.Item>
                          <NavDropdown.Item
                            as={Link}
                            to="/services/carbon-footprinting"
                            onClick={() => setIsOpen(false)}
                            onMouseEnter={() => handleHover(CarbonFootprinting)}
                            onMouseLeave={handleMouseLeave}
                          >
                            <li>Carbon Footprinting</li>
                          </NavDropdown.Item>
                        </ul>
                      </Col>
                      <Col className="trading-credits" md={4}>
                        <h5>Trading Carbon Credits</h5>
                        <ul>
                          <NavDropdown.Item
                            as={Link}
                            to="/services/selling-credits"
                            onClick={() => setIsOpen(false)}
                            onMouseEnter={() => handleHover(CarbonOffset)}
                            onMouseLeave={handleMouseLeave}
                          >
                            <li>Selling Credits</li>
                          </NavDropdown.Item>
                          <NavDropdown.Item
                            as={Link}
                            to="/services/buying-credits"
                            onClick={() => setIsOpen(false)}
                            onMouseEnter={() => handleHover(CarbonOffset)}
                            onMouseLeave={handleMouseLeave}
                          >
                            <li>Buying Credits</li>
                          </NavDropdown.Item>
                        </ul>
                      </Col>
                    </Row>
                    <Row className="header-banner w-100 h-50">
                      <img
                        className="header-banner-img"
                        src={hoveredImage}
                        alt="Hovered Item"
                      />
                    </Row>
                  </NavDropdown>
                  <Nav.Link as={Link} to="/insights">Insights</Nav.Link>
                  <Nav.Link as={Link} to="/about">About Us</Nav.Link>
                </Nav>
                <Button as={Link} to="/book" className="headerBtn">Book a Call</Button>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
}
